import React from "react";

const FamousResidentsItem = ({ item }) => {
  const getCategoryColor = (categoryType) => {
    switch (categoryType) {
      case "tech":
        return { backgroundColor: "#007bff", color: "white" }; // Blue
      case "entertainment":
        return { backgroundColor: "#e83e8c", color: "white" }; // Pink
      case "bollywood":
        return { backgroundColor: "#fd7e14", color: "white" }; // Orange
      case "sport":
        return { backgroundColor: "#28a745", color: "white" }; // Green
      case "hollywood":
        return { backgroundColor: "#6f42c1", color: "white" }; // Purple
      case "fashion":
        return { backgroundColor: "#6c757d", color: "white" }; // Gray
      case "gastronomy":
        return { backgroundColor: "#ffc107", color: "black" }; // Yellow
      case "crypto":
        return { backgroundColor: "#17a2b8", color: "white" }; // Light blue
      default:
        return { backgroundColor: "#6c757d", color: "white" };
    }
  };

  const categoryStyle = getCategoryColor(item.categoryType);

  return (
    <div
      className="famous-resident-card"
      style={{
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "25px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        margin: "0 0.5rem"
      }}
    >
      {/* Header */}
      <div>
        <h3 
          className="text-white mb-2"
          style={{ 
            fontSize: "1.1rem", 
            fontWeight: "bold",
            lineHeight: "1.3"
          }}
        >
          {item.name}
        </h3>

        <p 
          className="text-info mb-2"
          style={{ 
            fontSize: "0.9rem", 
            fontWeight: "600"
          }}
        >
          {item.profession}
        </p>

        {/* Status */}
        <div 
          className="status mb-2"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            padding: "0.3rem 0.6rem",
            borderRadius: "10px",
            fontSize: "0.75rem",
            color: "#17a2b8",
            fontWeight: "500",
            display: "inline-block"
          }}
        >
          {item.status}
        </div>

        {/* Quote */}
        <div 
          className="quote mb-2"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            padding: "0.8rem",
            borderRadius: "12px",
            borderLeft: "3px solid #17a2b8"
          }}
        >
          <p 
            className="text-light mb-0"
            style={{ 
              fontSize: "0.8rem", 
              lineHeight: "1.4",
              fontStyle: "italic"
            }}
          >
            "{item.quote}"
          </p>
        </div>

        {/* Country */}
        <div 
          className="country"
          style={{
            fontSize: "0.8rem",
            color: "#adb5bd"
          }}
        >
          <strong className="text-white">Ország:</strong> {item.country}
        </div>
      </div>
    </div>
  );
};

export default FamousResidentsItem;
